module.exports = __webpack_public_path__ + "static/media/1009291.6df55845.png";